import React, { useEffect } from 'react';

export default function NewSession() {

  useEffect(() => {
    sessionStorage.clear();

    fetch("api/ConsumerApplication/NewSession");

    // reset to home screen 
    window.location.href = '/';
  }, []);


  return (
    <div />
  )
}


// WEBPACK FOOTER //
// ./src/components/NewSession.js